/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ActualsDefinitionValueSets {
    MaterialDestinations = 0,
    MaterialTypes = 1,
    Stockpiles = 2,
    Staff = 3,
    EquipmentInDepartment = 4,
    AllEquipment = 5,
    LocationsInDepartment = 6,
}
